import { ClipboardPulseOutlineIcon } from './ClipboardPulseOutlineIcon';

/**
 * author: Simran
 * id 8D6CA1DD-35D6-4E8E-BDA0-6192728A24C4
 * name clipboard-pulse-outline
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-pulse-outline.svg
 * tags
 * - Medical / Hospital 
 */
export const ClipboardVitalsOutlineIcon = ClipboardPulseOutlineIcon;
export default ClipboardVitalsOutlineIcon